module.exports = __webpack_public_path__ + "static/media/BBVA.32dfa903.jpg";